import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import AssignJobModal from "./AssignJobModal";
import axios from "axios";
import dayjs from "dayjs";

const CompletedJobs = () => {
  const [openAssignModel, setopenAssignModel] = useState(false);
  const [openMoveModel, setopenMoveModel] = useState(false);
  const [subJobs, setSubJobs] = useState(null);

  const [filteredLeadRows, setFilteredLeadRows] = useState([]);
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  useEffect(() => {
    fetchCompletedJobList();
  }, []);

  const fetchCompletedJobList = async () => {
    let currentUserEmployeeID = localStorage.getItem("currentUserEmployeeID")
      ? localStorage.getItem("currentUserEmployeeID")
      : "-";

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/ASSIGNED/-/-/-/MAIN/1900-01-01/1900-01-01/-/-/-`;

    const currentUserRaw = localStorage.getItem("currentUser");
    const currentUser = JSON.parse(currentUserRaw);
    console.log("currentUser", currentUser);
    console.log("Access Group:", currentUser[0]?.accessgrp);

    const accessgrp_From_Local = currentUser[0]?.accessgrp;

    let apiUrl = "";

    if (accessgrp_From_Local === "ADMIN") {
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/COMPLETED/-/-/-/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;
    } else {
      // API FOR NON ADMIN USERS HERE
      apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/COMPLETED/${currentUserEmployeeID}/-/-/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;
    }

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("Completed Job List :", data);
      setFilteredLeadRows(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  const fetchSubJobList = async (jobID) => {
    console.log("inside fetchSubJobList empid of :", jobID);
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/ASSIGNED/${empID}/-/-/MAIN/1900-01-01/1900-01-01/-/-/-`;
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobMainList/${company_code_from_local_storage}/subjob/-/-/${jobID}/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      console.log("SubJob List :", data);
      setSubJobs(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
    }
  };

  const [selectedLeads, setSelectedLeads] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [selectedSubJobs, setSelectedSubJobs] = useState({});

  const statusMapping = {
    // newLead: "New Lead",
    newLead: "Unassigned",
    // qualified: "Qualified",
    qualified: "Completed",
    pending: "Pending",
    assigned: "Assigned",
  };

  const navigate = useNavigate();

  // const newJobForm = () => {
  //   navigate("/newJobForm");
  // };

  const toggleSubJob = (leadId, subJobId) => {
    setSelectedSubJobs((prev) => {
      const current = prev[leadId] || [];
      return {
        ...prev,
        [leadId]: current.includes(subJobId)
          ? current.filter((id) => id !== subJobId)
          : [...current, subJobId],
      };
    });
  };

  // const removeSubJob = (leadId, subJobId) => {
  //   setFilteredLeadRows((prev) =>
  //     prev.map((row) =>
  //       row.lead_id === leadId
  //         ? {
  //             ...row,
  //             sub_jobs: row.sub_jobs.filter((sj) => sj.id !== subJobId),
  //           }
  //         : row
  //     )
  //   );
  // };

  const openAssign = () => {
    console.log("open assign model clicked ");
    setopenAssignModel(true);
  };

  const onMoveToCompleted = () => {
    console.log("onMoveToCompleted model clicked ");
    setopenMoveModel(true);
  };

  const moveToCompletedJobs = (e) => {
    e.preventDefault();
    console.log("this job is moved to completed");
    setopenMoveModel(false);
    navigate("/jobs", { state: { defaultTab: "2" } });
    // navigate("/templates");
  };

  const closeMoveModal = (e) => {
    e.preventDefault();
    console.log("this move modal is closed");
    setopenMoveModel(false);
  };

  return (
    <div className="">
      <div className="flex justify-left items-center gap-4 mb-4">
        <h2 className="text-xl font-normal   mb-1">
          Completed Tasks ({filteredLeadRows?.length})
        </h2>
      </div>
      {selectedLeads.length > 0 && (
        <button
          className="bg-red-500 text-white text-xl px-1 pb-1 mb-2 rounded"
          onClick={() =>
            setFilteredLeadRows((prev) =>
              prev.filter((row) => !selectedLeads.includes(row.lead_id)),
            )
          }
        >
          <AiFillDelete className="inline-block " />
          {/* Delete Selected */}
        </button>
      )}
      <div className="overflow-auto max-h-[60vh] border">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th></th>
              <th className="shadow-sm px-1 py-0.5 text-center">
                <input
                  type="checkbox"
                  className="rounded border border-sm shadow"
                  onChange={(e) =>
                    setSelectedLeads(
                      e.target.checked
                        ? filteredLeadRows.map((row) => row.lead_id)
                        : [],
                    )
                  }
                  checked={
                    selectedLeads.length > 0 &&
                    selectedLeads.length === filteredLeadRows.length
                  }
                />
              </th>
              <th className="border pl-1 text-left font-normal">Task ID</th>
              <th className="border pl-1 text-left font-normal">Date</th>
              <th className="border pl-1 text-left font-normal">Customer</th>
              <th className="border pl-1 text-left font-normal">Creator</th>
              <th className="border pl-1 text-left font-normal">Create Date</th>
              <th className="border pl-1 text-left font-normal">
                Contact Person
              </th>
              <th className="border pl-1 text-left font-normal">
                Contact Phone
              </th>
              {/* <th className="border pl-1 text-left font-normal">Title</th> */}
              <th className="border pl-1 text-left font-normal">Email</th>
              <th className="border pl-1 text-left font-normal">
                Task Description
              </th>
              <th className="border pl-1 text-left font-normal">Progress</th>
              <th className="border pl-1 text-left font-normal">Task Status</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {filteredLeadRows.map((row) => (
              <React.Fragment key={row.Job_id}>
                <tr
                  key={row.Job_id}
                  className={
                    selectedLeads.includes(row.Job_id) ? "bg-blue-100" : ""
                  }
                >
                  <td className="border px-2 text-center">
                    <button
                      onClick={() => {
                        fetchSubJobList(row.Job_id);
                        setOpenRow(openRow === row.Job_id ? null : row.Job_id);
                      }}
                      className="text-gray-600 hover:text-black"
                    >
                      {openRow === row.Job_id ? (
                        <IoIosArrowUp size={18} />
                      ) : (
                        <IoIosArrowDown size={18} />
                      )}
                    </button>
                  </td>
                  <td className="border px-3 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={selectedLeads.includes(row.Job_id)}
                      className="rounded border border-sm shadow"
                      onChange={() =>
                        setSelectedLeads((prev) =>
                          prev.includes(row.Job_id)
                            ? prev.filter((id) => id !== row.Job_id)
                            : [...prev, row.Job_id],
                        )
                      }
                    />
                    {row?.Cnt > 0 ? (
                      <div className="rounded-full bg-gray-500 w-4 h-4 text-black font-semibold text-[0.6rem] flex justify-center items-center">
                        <span className="">{row?.Cnt}</span>
                      </div>
                    ) : (
                      <div className="rounded-full bg-transparent w-4 h-4 text-white text-[0.4rem] flex justify-center items-center">
                        <span className="">{"0000"}</span>
                      </div>
                    )}
                  </td>
                  <td className="border px-3 py-2">{row.Job_id}</td>
                  {/* <td className="border px-3 py-2">{row.Job_entryTime}</td> */}
                  <td className="border px-3 py-2">
                    {dayjs(row.Job_entryTime).format("DD-MMM-YYYY ")}{" "}
                  </td>
                  <td className="border px-3 py-2">{row.Job_organization}</td>
                  <td className="border px-3 py-2">{row.Job_salesperson}</td>
                  <td className="border px-3 py-2">
                    {dayjs(row.Job_entryTime).format("DD-MMM-YYYY ")}{" "}
                  </td>
                  <td className="border px-3 py-2">{row.Job_primarycontact}</td>
                  <td className="border px-3 py-2">{row.Job_phone}</td>
                  {/* <td className="border px-3 py-2">
                  {row.lead_primarycontacttitle}
                </td> */}
                  <td className="border px-3 py-2">{row.Job_email}</td>
                  <td className="border px-3 py-2">{row.Job_notes}</td>
                  <td className="border px-3 py-2">100%</td>
                  <td className="border px-3 py-2 text-center">
                    <button
                      className={`px-2 py-1 rounded text-white text-sm ${
                        row.lead_status === "newLead"
                          ? "bg-red-500"
                          : row.Job_status === "COMPLETED"
                            ? "bg-green-500"
                            : row.lead_status === "pending"
                              ? "bg-orange-500"
                              : row.lead_status === "assigned"
                                ? "bg-blue-500"
                                : "bg-gray-400"
                      }`}
                    >
                      {statusMapping[row.Job_status] || row.Job_status}
                    </button>
                  </td>
                </tr>

                {/* Collapsible Row */}
                <AnimatePresence>
                  {openRow === row.Job_id && (
                    <tr>
                      <td colSpan={13} className="p-0 border-t">
                        <motion.div
                          key={`details-${row.Job_id}`}
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3, ease: "easeInOut" }}
                          className="overflow-hidden bg-gray-50 px-4 py-2 text-sm text-gray-700"
                        >
                          {/* <div className="space-y-1">
            <p><strong>Contact Title:</strong> {row.lead_primarycontacttitle}</p>
            <p><strong>Organization:</strong> {row.lead_organization}</p>
            <p><strong>Email:</strong> {row.lead_email}</p>
            <p><strong>Phone:</strong> {row.lead_phone}</p>
            <p><strong>Notes:</strong> {row.lead_notes}</p>
            <p><strong>Status:</strong> {statusMapping[row.lead_status]}</p>
          </div> */}

                          <div className="text-sm text-gray-700">
                            <p className="mb-2 font-semibold">Tasks:</p>
                            {/* {row.sub_jobs && row.sub_jobs.length > 0 ? ( */}
                            {subJobs && subJobs?.length > 0 ? (
                              <ul className="space-y-2">
                                {/* {row.sub_jobs.map((subJob) => ( */}
                                {subJobs?.map((subJob) => (
                                  <li
                                    key={subJob.Job_id}
                                    className="flex justify-between items-center bg-white border rounded px-3 py-2 shadow-sm"
                                  >
                                    <label className="flex items-center gap-2 cursor-pointer">
                                      {/* <input
                                        type="checkbox"
                                        checked={
                                          selectedSubJobs[
                                            row.Job_id
                                          ]?.includes(subJob.id) || false
                                        }
                                        onChange={() =>
                                          toggleSubJob(row.Job_id, subJob.id)
                                        }
                                        //   className="accent-green-600"
                                        className="rounded border border-sm shadow accent-green-600"
                                      /> */}
                                      <span>{subJob.title}</span>
                                    </label>
                                    {/* Remove */}
                                    {/* <button
            onClick={() => removeSubJob(row.lead_id, subJob.id)}
            className="text-red-500 text-sm hover:underline"
          >
                      <AiFillDelete className="inline-block mr-1 text-xl p-0.5  rounded bg-red-500 text-white" />

          </button>*/}

                                    <div className="flex flex-col justify-left ">
                                      <span className="flex flex-col justify-left">
                                        <strong> Task Serial: </strong>{" "}
                                        {subJob.task_serial || "—"}
                                      </span>
                                      <br />
                                      <span className="flex flex-col justify-left">
                                        <strong>
                                          Task Created Date Time:{" "}
                                        </strong>{" "}
                                        {/* {subJob.Job_entryTime || "—"} */}
                                        {dayjs(subJob.Job_entryTime).format(
                                          "DD-MMM-YYYY hh:mm A",
                                        )}
                                        {""}
                                      </span>
                                    </div>
                                    <br />
                                    <div className="flex flex-col justify-left ">
                                      <span className="flex flex-col justify-left">
                                        <strong> Task Description: </strong>{" "}
                                        {subJob.task_description || "—"}
                                      </span>
                                      <br />
                                      <span className="flex flex-col justify-left">
                                        <strong> Scheduled Date Time: </strong>{" "}
                                        {dayjs(
                                          subJob.task_scheduledatetime,
                                        ).format("DD-MMM-YYYY hh:mm A")}
                                        {""}
                                      </span>
                                    </div>
                                    <div className="flex flex-col justify-left ">
                                      <span className="flex flex-col justify-left">
                                        <strong>Assignee:</strong>{" "}
                                        {subJob.task_assignedto || "—"}
                                      </span>
                                      <br />
                                      <span className="flex flex-col justify-left">
                                        <strong>Assigned Time:</strong>{" "}
                                        {subJob.task_scheduledatetime || "—"}
                                      </span>
                                    </div>
                                    <br />
                                    <div className="flex flex-col justify-left ">
                                      <span className="flex flex-col justify-left">
                                        <strong>Instruction:</strong>{" "}
                                        {subJob.task_instructions || "—"}
                                      </span>
                                      <span className="flex flex-col justify-left mt-2">
                                        <strong>Comments:</strong>{" "}
                                        {subJob.task_comments || "—"}
                                      </span>
                                    </div>
                                    <br />

                                    <div className="flex flex-col justify-left">
                                      <span className="flex flex-col justify-left mt-2">
                                        <strong>Task Target Date:</strong>{" "}
                                        {/* {subJob.task_targetdatetime || "—"} */}
                                        {dayjs(
                                          subJob.task_targetdatetime,
                                        ).format("DD-MMM-YYYY")}
                                        {""}
                                      </span>
                                      <br />
                                      <span>
                                        <strong>Attachments:</strong>
                                      </span>
                                      <ul className="list-disc list-inside text-sm">
                                        {subJob.attachments &&
                                        subJob.attachments.length > 0 ? (
                                          subJob.attachments.map(
                                            (file, idx) => (
                                              <li key={idx}>
                                                <a
                                                  href={file.url}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-600 hover:underline"
                                                >
                                                  {file.fileName}
                                                </a>{" "}
                                                {/* <span className="text-gray-500 text-xs">
                                                        ({file.uploadedAt})
                                                      </span> */}
                                              </li>
                                            ),
                                          )
                                        ) : (
                                          <li className="text-gray-500">
                                            No attachments
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p className="text-gray-400 italic">
                                No tasks found.
                              </p>
                            )}
                          </div>
                        </motion.div>
                      </td>
                    </tr>
                  )}
                </AnimatePresence>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {openAssignModel && (
          <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
            <div className="relative w-full max-w-xl bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-1 max-h-[50vh]">
              {/* Sticky Close Button */}
              <div className="bg-red-200 flex justify-between items-center">
                <h2 className="font-semibold ml-6">Choose Assign Person</h2>
                <div className="sticky top-0 bg-white z-20 p-2 flex justify-end">
                  <button
                    className="text-3xl text-black"
                    onClick={() => setopenAssignModel(false)}
                  >
                    &times;
                  </button>
                </div>
              </div>

              {/* Modal Content */}
              <div className="px-4 pb-4">
                <AssignJobModal />
              </div>
            </div>
          </div>
        )}
        {openMoveModel && (
          <div className="fixed bg-black bg-opacity-50 inset-0 flex justify-center items-center z-50">
            <div className="relative w-full max-w-lg bg-white rounded-2xl overflow-y-scroll hover:scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent p-6 max-h-[50vh]">
              {/* Sticky Close Button */}
              <h2 className="font-semibold ml-6 text-center text-xl">
                Are you sure to move this task to completed?
              </h2>
              <div className="flex justify-center items-center pt-4 gap-8">
                <button
                  className="text-lg text-white bg-blue-500 px-3 py-1 rounded "
                  onClick={(e) => moveToCompletedJobs(e)}
                >
                  Move
                </button>
                <button
                  className="text-lg text-white bg-gray-500 px-2 py-1 rounded"
                  onClick={(e) => closeMoveModal(e)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompletedJobs;
